import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { AlertCircle, XCircle, HelpCircle } from 'lucide-react';
export function PainPoints() {
  const pains = [{
    icon: <XCircle className="w-8 h-8 text-red-400" data-id="element-175" />,
    title: 'Publicas pero no vendes',
    desc: 'Creas contenido constantemente, subes reels, stories, pero tu cuenta bancaria sigue igual.'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-amber-400" data-id="element-176" />,
    title: 'Tienes ideas, cero ingresos',
    desc: 'Sabes que podrías enseñar algo, pero no tienes ni idea de cómo empaquetarlo y cobrar por ello.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-orange-400" data-id="element-177" />,
    title: 'Ves a otros facturar',
    desc: 'Ves gente con menos talento que tú vendiendo productos digitales y no entiendes cómo empezaron.'
  }];
  return <section className="py-20 px-4 bg-[#050510] relative" data-id="element-178">
      <div className="container mx-auto max-w-6xl" data-id="element-179">
        <ScrollReveal className="text-center mb-16" data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-181">
            ¿Te suena familiar?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-182">
            La mayoría de creadores están atrapados aquí.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-183">
          {pains.map((pain, index) => <ScrollReveal key={index} delay={index * 0.2} direction="up" className="h-full" data-id="element-184">
              <div className="glass-card p-8 rounded-2xl h-full border-t-4 border-t-red-500/50 hover:border-t-red-500 transition-all duration-300 group" data-id="element-185">
                <div className="mb-6 p-4 bg-white/5 rounded-full w-fit group-hover:scale-110 transition-transform duration-300" data-id="element-186">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-187">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-188">{pain.desc}</p>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}